import { render } from "@/components/pages/informationTabs/InformationTabs.html?vue&type=template&id=db1b4b90&external"
import script from "@/components/pages/informationTabs/InformationTabs.js?vue&type=script&lang=js&external"
export * from "@/components/pages/informationTabs/InformationTabs.js?vue&type=script&lang=js&external"

import "@/components/pages/informationTabs/InformationTabs.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__